import pmsInstance from '../instance'

const getPmsIntegration = () => {
	return pmsInstance.get('/pmsIntegrations')
}

export default getPmsIntegration
